import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import type { CreateFavouriteInterface } from "./favouriteServiceInterface/createFavouriteInterface";
import type { DeleteFavouriteInterface } from "./favouriteServiceInterface/deleteFavouriteInterface";
import { ResponseFavouriteByCityId } from "./favouriteServiceInterface/getFavouriteCityByAccountIdInterface";
import type { RequestGetFavouriteInterface } from "./favouriteServiceInterface/getListItemFavouriteInterface";
import {
  ResponseResultFavourite,
  ResponseToggleFavourite,
} from "./favouriteServiceInterface/getListItemFavouriteInterface";

class FavouriteServiceApi {
  private baseUrl: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "v2/account/favourite";
  }

  // ******************************************************
  // ****************** Method: Get ***********************
  // ******************************************************

  async getFavouriteCityByAccountId() // change to All
  : Promise<ResponseFavouriteByCityId> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/getCityIdByAccountId`,
      "GET",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      false,
    )) as any;

    return new ResponseFavouriteByCityId(response);
  }

  async getFavourite(
    params: RequestGetFavouriteInterface,
  ): Promise<ResponseResultFavourite> {
    const response = await apiRequest(
      this.baseUrl,
      `${this.basePath}?page=1&limit=99&city_id=${params.city_id}`,
      "GET",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      false,
    );
    return new ResponseResultFavourite(response);
  }

  // ******************************************************
  // ****************** Method: Post ***********************
  // ******************************************************
  async createFavourite(params: CreateFavouriteInterface) {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/create`,
      "POST",
      params,
      true,
    )) as any;
    return new ResponseToggleFavourite(response);
  }

  async deleteFavourite(params: DeleteFavouriteInterface) {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/delete`,
      "POST",
      params,
      true,
    )) as any;

    return new ResponseToggleFavourite(response);
  }
}

export default FavouriteServiceApi;
